module.exports = __webpack_public_path__ + "img/approve.14525a9c.svg";